import classes from "./TShirt.module.css"; // Ensure correct CSS import
import tshirt from "./tshirt.svg"; // Ensure image exists

const TShirt = () => {
  return (
    <section id="tshirt" className={classes.tshirtSec}>
      <div className={classes.tshirt}>
        <div className={classes.details}>
          <h3 className={classes.heading}>T-SHIRT</h3>
          <h2 className={classes.heading1}>TEKNO'25 TSHIRT</h2>
          <p className={classes.para}>
            Get your exclusive <strong>Teknodeon</strong> T-shirt ! The T-shirt offers a unique opportunity to showcase your passion for technology and innovation. 
            Custom-designed with cutting-edge graphics, these T-shirts symbolize the spirit of the event and its forward-thinking community. 
            Whether you're an <strong>attendee</strong>, <strong>speaker</strong>, or <strong>sponsor</strong>, wearing one is a way to express your involvement and enthusiasm. 
            <h2><br /><strong>Grab yours today and wear your tech Pride! </strong></h2><br />
          </p>
        </div>
        <div className={classes.composition}>
          <img className={classes.images} src={tshirt} alt="tshirt" />
        </div>
      </div>
    </section>
  );
};

export default TShirt;
